import React from "react";
import UserEvent from "../constants/user-event";
import { getVehicleDescription, getVehicleTitle } from "../utils/trade-in-car";
import { formatPrice } from "../utils/helpers";
import { VehicleCondition } from "@wayke-se/ecom";
import StoreAction from "../constants/store-action";
const vehicleConditionText = (condition) => {
    switch (condition) {
        case VehicleCondition.Ok:
            return "Helt okej skick";
        case VehicleCondition.Good:
            return "Bra skick";
        default:
            return "Mycket bra skick";
    }
};
export default (props) => {
    const vehicle = props.vehicleLookup.getVehicle();
    const { registrationNumber, milage, condition } = props.data.tradeInCar;
    const vehicleTitle = getVehicleTitle(vehicle);
    const vehicleDecsription = getVehicleDescription(vehicle);
    const valuation = !!vehicle.valuation
        ? formatPrice(Math.round(vehicle.valuation / 100) * 100)
        : null;
    const handleHasTradeInCar = (value) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            value,
            type: "tradeInCar",
            name: "hasTradeInCar",
        }, () => {
            props.onProceedToNextStep();
        });
    };
    const onPreviousStepClick = () => {
        props.onIncompleteUserEvent(UserEvent.BACK_BUTTON_CLICKED);
        props.onPreviousStepClick();
    };
    const onProceed = () => handleHasTradeInCar(true);
    return (React.createElement("div", { className: "page-main" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Inbytesbil"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null, "\u00C4r detta din inbytesbil?"))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { className: "repeat-m-half" },
                React.createElement("div", { "data-ecom-box": "" },
                    React.createElement("div", { "data-ecom-columnrow": "", className: "font-size-small m-b-half" },
                        React.createElement("div", { className: "column" },
                            React.createElement("div", { "data-ecom-label": "" },
                                registrationNumber,
                                ", ",
                                milage,
                                " mil")),
                        React.createElement("div", { className: "column" },
                            React.createElement("button", { "data-ecom-link": "font-inerit", onClick: props.onShowTradeInCarDefinition }, "\u00C4ndra"))),
                    React.createElement("div", { className: "m-t-half" },
                        React.createElement("span", { className: "font-medium" }, vehicleTitle),
                        " ",
                        vehicleDecsription))),
            React.createElement("div", { className: "repeat-m-half" },
                React.createElement("div", { "data-ecom-box": "light" },
                    React.createElement("div", { "data-ecom-columnrow": "" },
                        React.createElement("div", { className: "column" },
                            React.createElement("div", { className: "font-medium" }, vehicleConditionText(condition))),
                        React.createElement("div", { className: "column" },
                            React.createElement("button", { "data-ecom-button": "light small", onClick: onPreviousStepClick }, "\u00C4ndra")))))),
        valuation && (React.createElement("section", { className: "page-section text-center" },
            React.createElement("div", { className: "m-b-mini" }, "Ungef\u00E4rligt v\u00E4rde:"),
            React.createElement("div", { className: "h4 no-margin" },
                valuation,
                " kr"))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-alert": "" },
                React.createElement("div", { className: "alert-icon-section" },
                    React.createElement("div", { className: "alert-icon" },
                        React.createElement("i", { className: "icon-info no-margin" }))),
                React.createElement("div", { className: "alert-content" },
                    React.createElement("div", { className: "font-medium" }, "Vi skickar med uppgifter om din inbytesbil till bilhandlaren."),
                    " ",
                    "Observera att v\u00E4rderingen som utf\u00F6rs ger ett uppskattat inbytesv\u00E4rde. Det slutgiltliga v\u00E4rdet avg\u00F6rs n\u00E4r handlare kan bekr\u00E4fta bilens skick."))),
        React.createElement("section", { className: "page-section page-section-bottom" },
            React.createElement("div", { "data-ecom-buttonnav": "" },
                React.createElement("div", { className: "button-nav-item", onClick: onProceed },
                    React.createElement("button", { "data-ecom-button": "full-width" }, "G\u00E5 vidare"))))));
};
